export default {
  REDIRECT_LINK_FETCHED: 'REDIRECT_LINK_FETCHED',
  REDIRECT_LINK_LOAD: 'REDIRECT_LINK_LOAD',
  REDIRECT_LINK_TEMPLATES_FETCHED: 'REDIRECT_LINK_TEMPLATES_FETCHED',
  REDIRECT_LINK_TEMPLATES_LOAD: 'REDIRECT_LINK_TEMPLATES_LOAD',
  REDIRECT_LINK_DETAIL: 'REDIRECT_LINK_DETAIL',
  REDIRECT_LINK_BUTTON_LOAD: 'REDIRECT_LINK_BUTTON_LOAD',
};
